export default "__VITE_ASSET__Cn$yfK2i__"